import {
    Button,
    ButtonProps
} from "@mui/material";
import {
    PermissionResourceType,
    PermissionType
} from "../../../models";

import { useMemo } from "react";
import { usePermissionCheck } from "../../../lib/permission/cedar/hooks/usePermissionCheck";
import { useQuery } from "react-query";

interface PermissionRestrictedButtonProps extends ButtonProps {
    resourceId: string;
    resourceType: PermissionResourceType;
    requiredPermission: PermissionType;
    permissionOverridden?: boolean;
}

export const PermissionRestrictedButton = (props: PermissionRestrictedButtonProps) => {
    const { resourceId, resourceType, requiredPermission, permissionOverridden, ...buttonProps } = props;

    const { checkPermission, isReady } = usePermissionCheck();

    const shouldCheckPermission = props.disabled || permissionOverridden;

    const { data: isPermissionGranted } = useQuery<boolean>({
        queryKey: ["isPermissionGranted", resourceId, resourceType, requiredPermission],
        queryFn: async () => {
            return await checkPermission(resourceId, resourceType, requiredPermission);
        },
        enabled: isReady && shouldCheckPermission
    });

    const isEnabled = useMemo(() => {
        if (props.disabled) {
            return false;
        }
        if (permissionOverridden) {
            return true;
        }
        return isPermissionGranted ?? false;
    }, [props.disabled, permissionOverridden, isPermissionGranted]);

    return (
        <Button
            {...buttonProps}
            // Short term hard coding state not be disabled for property level permission workaround
            disabled={false}
        >
            {props.children}
        </Button>
    );
};